import React from 'react';
import { env } from '@admitkard/uiutils/env';
import { careerCss } from 'components/Career/Career.css';

interface SingleWorkProps {
  primaryContent: JSX.Element;
  secondaryContent: string | JSX.Element;
  index: number;
}
const SingleWork: React.FunctionComponent<SingleWorkProps> = (props) => {
  return (
    <div className={`work-step-x work-step-${props.index}`}>
      <div className="work-step-content">
        <div>
          <span className={`steps-img-bg step-${props.index}`} />
        </div>
        <div className='steps-content-block'>
          <div className='font-f steps-heading' >
            {props.primaryContent}
          </div>
          <div className='steps-secondary'>{props.secondaryContent}</div>
        </div>
      </div>
      {props.children}
      <style jsx>{careerCss}</style>
      <style jsx>{`
        .steps-img-bg.step-${props.index} {
          background-image: url('${env.getAssetUrl(`images/career-page/pointer_${props.index}_image_(web).png`)}')
        }
      `}</style>
    </div>
  );
};
const Work: React.FunctionComponent = () => {
  return (
    <>
      <div className='steps-wrapper'>
        <div className='why-h1 font-f'> Want to know what it's like to work at AdmitKard?</div>
        <div className='work-steps'>
          <SingleWork
            primaryContent={<>We know you are high value, but your <span className='step-underline'>healthcare</span> doesn’t need to be</>}
            secondaryContent="All-inclusive health insurance to save on your medical bills"
            index={1}
          >
            <SingleWork
              primaryContent={<>Refer us talent, and win exciting <span className='step-underline'>rewards</span></>}
              secondaryContent="Referral and reward system to recognize your keen eye for finding talent"
              index={2}
            >
              <SingleWork
                primaryContent={<>We’ve got the stash that we love to <span className='step-underline'>cash</span></>}
                secondaryContent="Performance-based incentives because creativity should never be taken for granted"
                index={3}
              >
                <SingleWork
                  primaryContent={<>Work smarter, <span className='step-underline'>Party harder</span></>}
                  secondaryContent="A plethora of interactive events organized each week to help ease your workload"
                  index={4}
                >
                </SingleWork>
              </SingleWork>
            </SingleWork>
          </SingleWork>
        </div>
      </div>
      <style jsx>{careerCss}</style>
    </>
  );
};
export {Work};
